export default __webpack_public_path__ + "static/media/1.444b4327.jpg";